export abstract class VariablesManager {
  abstract getValue(variableId: string): any;
  abstract setValue(variableId: string, value: any): void;

  abstract getValueByName(name: string): any;
  abstract setValueByName(name: string, value: any): void;
}
